import Index from "./Route/Route";
function App() {
  return (
    <div>
      <Index />
    </div>
  );
}

export default App;
